// extracted by mini-css-extract-plugin
export var actionIcon = "_ki-0";